import React from "react"

const MultiLineCell = ({ title, subtitle }) => {
  return (
    <>
      <div>{title}</div>
      <div className="vt-muted text-xs">{subtitle}</div>
    </>
  )
}

export default MultiLineCell
